// ** React Imports

import { lazyImport } from "../../utility/lazyImport";
const { Login } = lazyImport(() => import("../../features/auth"), "Login");
const { Signup } = lazyImport(() => import("../../features/auth"), "Signup");
const { ForgetPassword } = lazyImport(() => import("../../features/auth"), "ForgetPassword");
const { SetNewPassword } = lazyImport(() => import("../../features/auth"), "SetNewPassword");


const AuthenticationRoutes = [
  {
    path: "/signin",
    element: <Login />,
    meta: {
      layout: "blank",
      publicRoute: true,
      restricted: true,
    },
  },
  {
    path: "/signup",
    element: <Signup />,
    meta: {
      layout: "blank",
      publicRoute: true,
      restricted: true,
    },
  },
  {
    path: "/forget-password",
    element: <ForgetPassword />,
    meta: {
      layout: "blank",
      publicRoute: true,
      restricted: true,
    },
  },
  {
    path: "/reset-password/:token",
    element: <SetNewPassword />,
    meta: {
      layout: "blank",
      publicRoute: true,
      restricted: true,
    },
  },
];

export default AuthenticationRoutes;
